module.exports = __webpack_public_path__ + "static/Curbix-5-e5ee2dd71c74e0d71100c97afad2f62e.jpg";